const getError = require('../tools/get-error')

function rmsFetch ({ logger, fetch, token, baseUrl, timeout = 30000 }) {
  const fetcher = async ({ path, body, method }) => {
    const url = `${baseUrl}${path}`

    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }

    const options = {
      method,
      headers
    }

    if (body) {
      options.body = JSON.stringify(body)
    }

    let timeoutId
    const timeoutPromise = new Promise((resolve, reject) => {
      timeoutId = setTimeout(() => {
        logger.error(`RmsFetch: request timeout after ${timeout}ms for ${url}`)
        reject(new Error(`Request timeout after ${timeout}ms`))
      }, timeout)
    })

    const fetchPromise = fetch(url, options).then(async (res) => {
      if (!res.ok) {
        logger.error(`RmsFetch: error fetching ${url}`)
        await getError(res)
      }
      return res
    })

    try {
      const res = await Promise.race([fetchPromise, timeoutPromise])
      clearTimeout(timeoutId)
      return res
    } catch (error) {
      clearTimeout(timeoutId)
      throw error
    }
  }

  return fetcher
}

module.exports = rmsFetch
